import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "invoices"
    }}>{`Invoices`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Billing customers is a critical business activity, but creating invoices is tedious and time consuming. While accuracy is paramount, invoice data often comes from several systems and changes regularly, so the process can be prone to error. Finance and accounting teams at start-ups and enterprises alike need invoicing solutions that are accurate, reliable, and can scale as the business grows.`}</p>
    <p>{`Adobe Acrobat Services can help businesses create invoices. After pulling relevant data from the various systems (CRM, ERP, PIM, etc.) into a JSON file, users can:`}</p>
    <ul>
      <li parentName="ul">{`Design invoice templates in Microsoft Word and add text tags for merging JSON data`}</li>
      <li parentName="ul">{`Create invoices on demand using an automation tool, such as Microsoft Power Automate`}</li>
      <li parentName="ul">{`Add password protection to prevent the editing of PDFs`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`At the end of every month, a member of the accounting department at a medical supply company needs to send out customer invoices. Information is pulled from different systems and PDF invoices are generated programmatically. With differing billing periods, generating invoices, whether in batches or one at a time, must be quick and accurate.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Design an invoice template in Microsoft Word`}</li>
      <li parentName="ol">{`Import JSON file and use the Adobe Document Generation Tagger, a Microsoft Word Add-In, to auto generate text tags`}</li>
      <li parentName="ol">{`Apply any necessary logic and conditions using the Adobe Document Generation Tagger`}</li>
      <li parentName="ol">{`Use the Adobe Document Generation API to merge data from the JSON into the template to create PDF invoices`}</li>
      <li parentName="ol">{`Add password protection to prevent editing using the Adobe PDF Services API`}</li>
    </ol>
    <h3 {...{
      "id": "building-in-power-automate"
    }}>{`Building in Power Automate`}</h3>
    <ul>
      <li parentName="ul">{`Adobe PDF Services Connector (includes Document Generation and Protect)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      